export default {"src":"/_next/static/media/creepyCat.03434339.svg","height":14,"width":122};